// extracted by mini-css-extract-plugin
module.exports = {"link":"_3HCmE","root":"_193ed","bg":"_1h45b","label":"_1E9Uq","top":"_3eh6j","bottom":"_3p-ms"};